import { render, staticRenderFns } from "./TerritoryActionDelete.vue?vue&type=template&id=6b99ad03&"
import script from "./TerritoryActionDelete.vue?vue&type=script&lang=ts&"
export * from "./TerritoryActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports